/**
 * Single source of truth for status colors used across the OnGo flow
 * (exercise feedback, summary chips, etc.). Keeps the green/red signalling
 * identical between the gameplay screen and the summary screen.
 */
export const ON_GO_COLORS = {
  correct: '#00b530',
  incorrect: '#ff1919',
  correctSoft: 'rgba(0, 181, 48, 0.08)',
  incorrectSoft: 'rgba(255, 25, 25, 0.08)',
} as const;
